// Must match backend RetrieverName in hybrid_search.py.
export const MATCHED_QUERY = {
  ISBN: "isbn_match",
  KEYWORD: "keyword_match",
  SEMANTIC: "semantic_match",
} as const;

export type MatchSource = "isbn" | "keyword" | "semantic";

const DISPLAY_ORDER: readonly MatchSource[] = ["isbn", "keyword", "semantic"];

const WIRE_TO_SOURCE: Record<string, MatchSource> = {
  [MATCHED_QUERY.ISBN]: "isbn",
  [MATCHED_QUERY.KEYWORD]: "keyword",
  [MATCHED_QUERY.SEMANTIC]: "semantic",
};

// always returns the match sources in the display order
export function deriveMatchSources(
  matchedQueries: readonly string[] | undefined,
): MatchSource[] {
  if (!matchedQueries?.length) return [];

  const present = new Set<MatchSource>(
    matchedQueries
      .map((wire) => WIRE_TO_SOURCE[wire])
      .filter((source): source is MatchSource => Boolean(source)),
  );

  return DISPLAY_ORDER.filter((source) => present.has(source));
}
